function invalid(code, message) {
    return { ok: false, code, message };
}
function hasText(value) {
    return typeof value === "string" && value.trim().length > 0;
}
export function validateUrgentGameUpdate(item) {
    if (item.kind !== "urgent-game-update") {
        return invalid("wrong-kind", "Expected urgent-game-update");
    }
    if (!hasText(item.id) || item.display.id !== item.id) {
        return invalid("identity-mismatch", "Item and display identities must be equal and non-empty");
    }
    if (!hasText(item.availableAtUtc)) {
        return invalid("missing-availability", "A publication time is required");
    }
    if (!hasText(item.display.headline) ||
        !hasText(item.display.dek) ||
        !hasText(item.display.scoreLockup)) {
        return invalid("missing-copy", "Headline, supporting copy and score state are required");
    }
    if (item.display.action !== "Follow game") {
        return invalid("invalid-action", "The action must be Follow game");
    }
    if (item.interaction.destination.type !== "game-screen" ||
        !hasText(item.interaction.destination.gameId) ||
        !hasText(item.interaction.accessibleName)) {
        return invalid("invalid-destination", "A typed game destination and accessible action name are required");
    }
    if (item.display.media ||
        item.display.games ||
        item.display.metrics?.length ||
        item.display.bullets?.length ||
        item.display.flowPoints?.length ||
        item.display.sequenceSteps?.length) {
        return invalid("unsupported-content", "Urgent game updates are text, score and action only");
    }
    return { ok: true };
}
